module.exports = __webpack_public_path__ + "static/media/activity_replies.9189f728.svg";